import { IAppState } from '../../redux';

export function selectIsAutobrokerEnabled(state: IAppState): boolean {
  const {
    auction: {
      strategy: { isEnabled },
    },
  } = state;

  return isEnabled;
}
